import apiClient from "./apiClient";

export const fetchPromotions = async () => {
    const response = await apiClient.get("/api/promotion/all");
    return response.data;
};

export const createPromotion = async (formData) => {
    const response = await apiClient.post("/api/promotion", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
};

export const updatePromotion = async (id, formData) => {
    const response = await apiClient.put(`/api/promotion/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
};

export const deletePromotion = async (id) => {
    await apiClient.delete(`/api/promotion/${id}`);
};